exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**\n * Mixins\n */\n.user-view ul > li {\n  list-style-type: none; }\n  .user-view ul > li label {\n    font-size: 13px; }\n\n.user-view .wish-item a {\n  display: block;\n  font-size: 13px; }\n\n.user-view .no-wish {\n  color: #5f5f5f;\n  font-style: italic;\n  font-size: 14px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/components/users/user-view/user-view.component.scss
// module id = ../../../../../src-admin/app/components/users/user-view/user-view.component.scss
// module chunks = main